import PropTypes from 'prop-types'
import React from 'react'

const ReplaceTag = ({ pattern }) => <code>&lt;&lt;{pattern}&gt;&gt;</code>

ReplaceTag.propTypes = {
  pattern: PropTypes.string.isRequired
}

export default ReplaceTag
